module.exports = __webpack_public_path__ + "static/media/earthfriends.b91f0005.svg";